import { Action } from '@ngrx/store';
import { Error } from '../../_models/auth.models';
import { Reference } from 'src/app/core/utils/action-helper.util';

/**
 * Layouts action types
 */
export enum AuditLogActionTypes {
  RESEND_EMAIL = '[AuditLog] Resend Email',
  RESEND_EMAIL_SUCCESS = '[AuditLog] Resend Email Success',
  RESEND_EMAIL_FAILED = '[AuditLog] Resend Email Failed',
  FORWARD_EMAIL = '[AuditLog] Forward Email',
  FORWARD_EMAIL_SUCCESS = '[AuditLog] Forward Email Success',
  FORWARD_EMAIL_FAILED = '[AuditLog] Forward Email Failed',
  LOAD_NOTIFICATION_LOG = '[AuditLog] Load Notification Log',
  LOAD_NOTIFICATION_LOG_SUCCESS = '[AuditLog] Load Notification Log Success',
  LOAD_NOTIFICATION_LOG_FAILED = '[AuditLog] Load Notification Log Failed',
}

/**
 * Operations
 */

export class ResendEmail extends Reference implements Action {
  readonly type = AuditLogActionTypes.RESEND_EMAIL;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public payload:any, public force: boolean = false) {
    super();
  }
}

export class ResendEmailSuccess extends Reference implements Action {
  readonly type = AuditLogActionTypes.RESEND_EMAIL_SUCCESS;

  constructor(public payload: any) {
    super();
  }
}

export class ResendEmailFailed extends Reference implements Action {
  readonly type = AuditLogActionTypes.RESEND_EMAIL_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class ForwardEmail extends Reference implements Action {
  readonly type = AuditLogActionTypes.FORWARD_EMAIL;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public payload:any) {
    super();
  }
}

export class ForwardEmailSuccess extends Reference implements Action {
  readonly type = AuditLogActionTypes.FORWARD_EMAIL_SUCCESS;

  constructor(
    public payload: any
  ) {
    super();
  }
}

export class ForwardEmailFailed extends Reference implements Action {
  readonly type = AuditLogActionTypes.FORWARD_EMAIL_FAILED;

  constructor(public payload: Error) {
    super();
  }
}
export class LoadNotificationLog extends Reference implements Action {
  readonly type = AuditLogActionTypes.LOAD_NOTIFICATION_LOG;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public appId:string,public tableId:string, public id:string) {
    super();
  }
}

export class LoadNotificationLogSuccess extends Reference implements Action {
  readonly type = AuditLogActionTypes.LOAD_NOTIFICATION_LOG_SUCCESS;

  constructor(
    public appId:string, 
    public tableId:string,
    public id:string,
    public payload: any
  ) {
    super();
  }
}

export class LoadNotificationLogFailed extends Reference implements Action {
  readonly type = AuditLogActionTypes.LOAD_NOTIFICATION_LOG_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

/**
 * Available types
 */
export type Actions =
  | ResendEmail
  | ResendEmailSuccess
  | ResendEmailFailed
  | ForwardEmail
  | ForwardEmailSuccess
  | ForwardEmailFailed
  | LoadNotificationLog
  | LoadNotificationLogSuccess
  | LoadNotificationLogFailed
